<div fxLayoutAlign="center center">
  <mat-form-field fxFlex="40%">
    <input matInput type="text" (keyup)="doFilter($event.target.value)" placeholder="Filter">
  </mat-form-field>
</div>

<table mat-table [dataSource]="dataSource" class="mat-elevation-z8" matSort>

  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef mat-sort-header="name">Name</th>
    <td mat-cell *matCellDef="let element"> {{ element.name }} </td>
  </ng-container>

  <ng-container matColumnDef="date">
    <th mat-header-cell *matHeaderCellDef mat-sort-header="date">Date</th>
    <td mat-cell *matCellDef="let element"> {{ element.date.toDate()  | date}} </td>
  </ng-container>

  <ng-container matColumnDef="calories">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Calories</th>
    <td mat-cell *matCellDef="let element"> {{ element.calories | number }} </td>
  </ng-container>

  <ng-container matColumnDef="duration">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Duration</th>
    <td mat-cell *matCellDef="let element"> {{ element.duration | number }} </td>
  </ng-container>

  <ng-container matColumnDef="state">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>State</th>
    <td mat-cell *matCellDef="let element"> {{ element.state }} </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>

<mat-paginator #paginator
              [length]="100"
              [pageSize]="5"
              [pageSizeOptions]="[5, 10, 20]">
</mat-paginator>
